
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/blog/[blogId]",
      function () {
        return require("private-next-pages/news/blog/[blogId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/blog/[blogId]"])
      });
    }
  